// this is the entrypoint to your main application

import { render } from './components/region/region';

export const load = hostElement =>
	new Promise(resolve => {
		// render our region component
		render(hostElement);

		resolve();
	});
